import React from "react";
import { Image } from "../../../../../../../components/Image";
import "./style.css";

export const PcPayRemainPopup = ({ openPayRemainPopup, closePayPopup, display, userName }) => {
  return (
    <div className="pay-remain-popup-pc" style={{display: display ? "" : "none"}}>
      <div className="card">
        <div className="frame">
          <div className="headline">Did you know?</div>

          <div className="trailing-icon">
            <div className="icon">
              <Image className="icons-clear"
                  alt="Icons clear"
                  onClick={closePayPopup}
                  src="/static/image/questionnaire/fasting/pay-remain-popup/pc/icons-clear-24px.svg" />
            </div>
          </div>
        </div>

        <div className="div">
          <div className="frame-2">
            <p className="element-of-users-who">
              <span className="text-wrapper">83%</span>

              <span className="span"> of users who started their </span>

              <span className="text-wrapper">
                  intermittent fasting journey with Calo
                </span>

              <span className="span">
                  {" "}
                advanced in their goals within the first month
                </span>
            </p>

            <div className="frame-3">
              <Image src="/static/image/questionnaire/fasting/pay-remain-popup/pc/vector.svg" alt="Vector" className="vector" />

              <p className="we-want-you-to-find">
                  <span className="text-wrapper-2">
                    We want you to find success so we are offering the{" "}
                  </span>

                <span className="text-wrapper">additional discount</span>

                <span className="text-wrapper-2"> on your </span>

                <span className="text-wrapper">Intermittent Fasting Plan.</span>
              </p>
            </div>

            <p className="p">
              *Based on data from users who keep track of their progress
              with us.
            </p>
          </div>

          <div className="frame-wrapper">
            <Image src="/static/image/questionnaire/fasting/pay-remain-popup/pc/frame.png" alt="Frame" className="img" />
          </div>
        </div>

        <button className="button" onClick={openPayRemainPopup}>
          <div className="continue">
            <div className="text">Got It</div>
          </div>
        </button>
      </div>
    </div>
  );
};
